import {MITTWALD_API, Schemas} from '../middleware/MittwaldApi'
import * as ActionTypes from '../constants/ActionTypes'

import {queryCartShare, queryNewCartFromTemplate} from './Cart'
import {_auth, _customerNumber, _token, getSimpleModeFlag} from "../selectors/GetParam";
import {putFormData} from "./FormData";
import {getCookie} from "../util/util";

// **************************************************************************************************************


const fetchAuthenticatedClientData = (bearer, customerNumber) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.CLIENTDATA_REQUEST, ActionTypes.CLIENTDATA_SUCCESS, ActionTypes.CLIENTDATA_FAILURE],
        endpoint: `customers/${customerNumber}/contractpartner`,
        schema: Schemas.CLIENT_DATA,
        bearer: bearer,
        method: 'GET',
        payload: {
            customerNumber
        }
    }
})


const fetchBearerToken = () => ({
    [MITTWALD_API]: {
        types: [ActionTypes.BEARER_TOKEN_REQUEST, ActionTypes.BEARER_TOKEN_SUCCESS, ActionTypes.BEARER_TOKEN_FAILURE],
        endpoint: 'authenticate',
        schema: Schemas.BEARER_TOKEN,
        method: 'POST',
        postData: {}
    }
})

const fetchBearerTokenSpecial = (tempToken, customerNumber) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.BEARER_TOKEN_REQUEST, ActionTypes.BEARER_TOKEN_SUCCESS, ActionTypes.BEARER_TOKEN_FAILURE],
        endpoint: `authenticate/token`,
        schema: Schemas.BEARER_TOKEN,
        method: 'POST',
        postData: {
            username: customerNumber,
            sudo: "true",
            ttl: 10000,
        },
        customHeaders: {
            auth: {
                key: "Authorization",
                value: "Bearer " + tempToken
            },
            accept: {
                key: "Accept",
                value: "application/json"
            }
        }
    }
})

const cachedBearerToken = () => ({

    type: ActionTypes.BEARER_TOKEN_CACHE

})

export const queryBearerToken = (forceNew = false) => (dispatch, getState) => {

    /**
     * Functionality to test with custom token
     */
    if (!forceNew && _token && _customerNumber && !getState().appState.isAuthenticatedUser) {
        dispatch({
            type: ActionTypes.BEARER_TOKEN_SUCCESS,
            response: {
                entities: {
                    tokens: {
                        token: {
                            token: _token,
                            expires: new Date().getTime() + 86400 * 1000
                        }
                    }
                }
            }
        })
        return dispatch(fetchAuthenticatedClientData(getState().token.bearer, _customerNumber))
    }

    if (
        (_customerNumber && _auth && !getState().appState.isAuthenticatedUser) ||
        getState().token.bearer === "" ||
        new Date().getTime() > new Date(getState().token.expires).getTime() ||
        forceNew
    ) {

        if (_customerNumber && _auth) {

            return dispatch(fetchBearerTokenSpecial(_auth, _customerNumber)).then(args => {
                return dispatch(fetchAuthenticatedClientData(getState().token.bearer, _customerNumber))
            });

        } else {

            return dispatch(fetchBearerToken())

        }

    } else {
        // return promise to match MittwaldApi return type ().then()
        return new Promise(resolve => {
            resolve(dispatch(cachedBearerToken()))
        })

    }
}

// **************************************************************************************************************

const fetchUserAuthentication = (username, password, multiFactorCode = null, deviceId = null) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.AUTHENTICATION_REQUEST, ActionTypes.AUTHENTICATION_SUCCESS, ActionTypes.AUTHENTICATION_FAILURE],
        endpoint: `authenticate`,
        //credentials: 'include',
        schema: Schemas.BEARER_TOKEN,
        method: 'POST',
        postData: {
            username,
            password,
            multiFactorCode,
            deviceId
        }
    }
})

const fetchClientNumber = (bearer, clientType, accountName) => {

    let endpointPartial = ""

    switch (clientType) {

        default:
        case 'paccount':
            endpointPartial = "accounts"
            break

        case 'reseller':
            endpointPartial = "resellers"
            break

    }

    return {
        [MITTWALD_API]: {
            types: [ActionTypes.CLIENTNUMBER_REQUEST, ActionTypes.CLIENTNUMBER_SUCCESS, ActionTypes.CLIENTNUMBER_FAILURE],
            endpoint: `${endpointPartial}/${accountName}`,
            schema: Schemas.JSON,
            bearer: bearer,
            method: 'GET'
        }
    }
}

export const cachedCustomerAuthentication = () => ({
    type: ActionTypes.AUTHENTICATION_CACHED
})

const queryAuthenticatedClientData = (accountName) => (dispatch, getState) => {

    switch (accountName.charAt(0)) {

        case "r":
            return dispatch(fetchClientNumber(getState().token.bearer, "reseller", accountName)).then(args => {
                if (args.type === ActionTypes.CLIENTNUMBER_SUCCESS) {
                    return dispatch(fetchAuthenticatedClientData(getState().token.bearer, args.response.result.customerNumber))
                } else {
                    return false
                }
            })

        case "p":
            return dispatch(fetchClientNumber(getState().token.bearer, "paccount", accountName)).then(args => {
                if (args.type === ActionTypes.CLIENTNUMBER_SUCCESS) {
                    return dispatch(fetchAuthenticatedClientData(getState().token.bearer, args.response.result.customerNumber))
                } else {
                    return false
                }
            })

        default:
            return dispatch(fetchAuthenticatedClientData(getState().token.bearer, accountName))

    }

}

export const queryUserAuthentication = (username, password, multiFactorCode) => (dispatch, getState) => {

    const oldToken = getState().token.bearer

    const deviceId = getCookie('device_id');

    return dispatch(fetchUserAuthentication(username, password, multiFactorCode, deviceId)).then(args => {
        if (args.type === ActionTypes.AUTHENTICATION_FAILURE) {
            return args
        }
        return Promise.all(
            [
                dispatch(queryCartShare(oldToken)).then(args => {

                    const shareTemplateId = args.response.result.id

                    return dispatch(queryNewCartFromTemplate(shareTemplateId)).then(args => {
                        if (!getSimpleModeFlag()) {
                            return dispatch(putFormData())
                        }
                    })

                }),
                dispatch(queryAuthenticatedClientData(username))
            ]
        )
        // share cart
        // create new cart with new token
        // put form data
    })
}


// **************************************************************************************************************
export const existingCustomerSelected = () => (dispatch, getState) => {

    return dispatch({
        type: ActionTypes.CLIENTDATA_SELECT_EXISTING
    });

}

export const newCustomerSelected = () => (dispatch, getState) => {

    const oldToken = getState().token.bearer

    dispatch({
        type: ActionTypes.CLIENTDATA_SELECT_NEW
    })

    return dispatch(queryBearerToken(true)).then(args => {

        return Promise.all(
            [
                dispatch(queryCartShare(oldToken)).then(args => {

                    const shareTemplateId = args.response.result.id

                    return dispatch(queryNewCartFromTemplate(shareTemplateId)).then(args => {
                        if (!getSimpleModeFlag()) {
                            return dispatch(putFormData())
                        }
                    })

                }),
            ]
        )

    })

}



/** WEBPACK FOOTER **
 ** ./src/actions/UserAuthentication.js
 **/